import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const NavbarMobileMenu = ({ isOpen, onClose, onNavigate, whatsappLink }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.18, ease: 'easeInOut' }}
          className="lg:hidden w-full bg-white/98 backdrop-blur-xl border-b border-gray-200 shadow-xl overflow-hidden"
        >
          <div className="px-5 py-4 space-y-2 max-w-7xl mx-auto">
            <button
              type="button"
              onClick={() => onNavigate('features')}
              className="w-full flex items-center justify-between py-3 px-3.5 rounded-xl text-left font-semibold text-gray-800 hover:text-[#067978] hover:bg-teal-50/60 transition-all text-sm cursor-pointer"
            >
              <span>Features</span>
              <ArrowRight size={16} className="text-gray-400" />
            </button>
            <button
              type="button"
              onClick={() => onNavigate('how-it-works')}
              className="w-full flex items-center justify-between py-3 px-3.5 rounded-xl text-left font-semibold text-gray-800 hover:text-[#067978] hover:bg-teal-50/60 transition-all text-sm cursor-pointer"
            >
              <span>How It Works</span>
              <ArrowRight size={16} className="text-gray-400" />
            </button>
            <button
              type="button"
              onClick={() => onNavigate('get-started')}
              className="w-full flex items-center justify-between py-3 px-3.5 rounded-xl text-left font-semibold text-gray-800 hover:text-[#067978] hover:bg-teal-50/60 transition-all text-sm cursor-pointer"
            >
              <span>Get Started</span>
              <ArrowRight size={16} className="text-gray-400" />
            </button>
            <button
              type="button"
              onClick={() => onNavigate('faqs')}
              className="w-full flex items-center justify-between py-3 px-3.5 rounded-xl text-left font-semibold text-gray-800 hover:text-[#067978] hover:bg-teal-50/60 transition-all text-sm cursor-pointer"
            >
              <span>FAQs</span>
              <ArrowRight size={16} className="text-gray-400" />
            </button>

            <div className="pt-2 border-t border-gray-100">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onClose}
                className="w-full flex items-center justify-center gap-2 py-3 bg-[#067978] hover:bg-[#056362] text-white font-bold text-sm rounded-xl shadow-md transition-all mt-1"
              >
                Book a Demo
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NavbarMobileMenu;
